import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import { useSnackbar } from 'notistack';
import SentimentDissatisfiedIcon from '@mui/icons-material/SentimentDissatisfied';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';

export default function UnscheduleReasonModal(props) {
    const handleClose = () => {
        props.Close('');
        //setisShown(false);
    };
    const [unscheduleReason, setUnscheduleReason] = React.useState('--Select a Reason--');
    const [unscheduleReasonOther, setUnscheduleReasonOther] = React.useState('');
    const [formValidation, setFormValidation] = React.useState({
        isValid: false,
        errors: []
    });
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    function checkKeyPress(e) {
        const { key, keyCode } = e;
       // console.log(key, keyCode);
        if (keyCode === 13) {
            validateAndClose();
        }
    }


    function validate() {

        let isValid = true;
        let errors = [];

        if (unscheduleReason === '--Select a Reason--') {
            errors["GeneralError"] = "You must select a reason";
            isValid = false;
        }
        else if (unscheduleReason === 'Other' && unscheduleReasonOther.trim() === '') {
            errors["GeneralError"] = "Please give us a few details";
            isValid = false;
        }
   

        setFormValidation({
            isValid: isValid,
            errors: errors
        });

        return {
            isValid: isValid,
            errors: errors
        }
    }

    function validateAndClose() {

        if (validate().isValid) {
            let reason = '';
            if (unscheduleReason === 'Other') {
                reason = unscheduleReasonOther.trim();
            }
            else {
                reason = unscheduleReason;
            }
            props.OnAccept(reason);
        }
    }

    function handleUnscheduleReasonChanged(e) {
        setUnscheduleReason(e.target.value);
    }

    function handleOtherChange(e) {
        setUnscheduleReasonOther(e.target.value);
       
    }

    return (<div>
        <Dialog
            open={true}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
                <div style={{ display: 'flex' }}><SentimentDissatisfiedIcon sx={{ color: 'var(--sipzee-red)', fontSize: 30, marginRight: '5px' }} /><div style={{ alignSelf: 'center' }}>Unscheduling makes customers sad</div></div>
            </DialogTitle>
            <DialogContent>
                <div>
                    <div>This customer was planning on you picking up their order so please only unschedule if you must.
                        Are you sure you want to cancel this pick up, remove it from your orders, and have us update the customer?</div>
                    <div style={{ marginTop:'15px', display:'flex', flexDirection:'column' }}>
                        <div style={{alignSelf:'center'} }>
                            <FormControl fullWidth>
                            <InputLabel id="unschedule-reason-label">Reason</InputLabel>
                            <Select
                                    labelId="unschedule-reason-label"
                                    value={unscheduleReason}
                                    onChange={handleUnscheduleReasonChanged}
                                    label={unscheduleReason}
                                    variant='outlined'
                                    style={{maxWidth:'300px', minWidth:'250px'} }
                            >
                                <MenuItem value={'--Select a Reason--'}>--Select a reason--</MenuItem>
                                <MenuItem value={'My schedule has changed'}>My schedule has changed</MenuItem>
                                <MenuItem value={'Pickup is too large'}>Pickup is too large</MenuItem>
                                <MenuItem value={'Pickup is too expensive'}>Pickup is too expensive</MenuItem>
                                <MenuItem value={'Other'}>Other</MenuItem>
                            </Select>
                                </FormControl>
                        </div>
                        {unscheduleReason === 'Other' ?
                            <div style={{marginTop:'5px', alignSelf:'center'} }>
                                <TextField onChange={handleOtherChange} placeholder={'Unschedule reason'} value={unscheduleReasonOther} variant="outlined" style={{ maxWidth: '300px', minWidth: '250px' }} />
                             </div>
                            : null
                        }
                        {!formValidation.isValid ?
                            <div style={{ color: 'var(--sipzee-red)' }}>
                                {formValidation.errors["GeneralError"] == undefined ? null : formValidation.errors["GeneralError"]}
                            </div>
                            : null}
                     

                    </div>
                </div>

            </DialogContent>
            <DialogActions>
                <div style={{display:'flex',justifyContent:'space-between', width:'100%'} }>
                <Button onClick={props.Close}>
                    Cancel
                </Button>
                <Button onClick={validateAndClose} variant="contained" autoFocus>
                   Unschedule
                    </Button>
                </div>
            </DialogActions>
        </Dialog>
    </div>
    );

}